import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import ManageClientsComponent from '@app/components/manage-clients/list';

const ManageClient: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>Manage Clients</PageTitle>
      <ManageClientsComponent />
    </>
  );
};

export default ManageClient;
